// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MenuPage{--header-height: 98px;height:calc(100vh - var(--header-height) - 66px)}\n", ""]);
// Exports
module.exports = exports;
